import $ from 'jquery';

export default {
    name: "sidebar",
    components: {},
    props: [],
    data() {
        return {
            articles: false,
            autorisation: false,
        };
    },

    computed: {
        userCredentials() {
            return this.$store.getters["authInfo"];
        },
        activeRole() {
            return this.$store.getters["activeRole"];
        },
        isLogistics() {
            const roles = this.userCredentials && this.userCredentials.user && this.userCredentials.user.roles || [];
            if (this.$route.path === '/espaces' && roles.some(role => role.nom === 'ROLE_RESPONSABLE_LOGISTIQUE')) return true;
            if (this.activeRole && this.activeRole.nom) return this.activeRole.nom === 'ROLE_RESPONSABLE_LOGISTIQUE';
            return roles.some(role => role.nom === 'ROLE_RESPONSABLE_LOGISTIQUE');
        },
        selectedStockSpace() {
            if (!this.isLogistics || this.$route.path === '/espaces') return null;
            const space = this.$store.getters['activeStockSpace'];
            const stocks = this.$store.getters['stocks'] || [];
            const stockRouteId = this.$route.path.match(/^\/stock\/(?:show|echange)\/(\d+)/);
            if (stockRouteId && space && String(space.id) !== stockRouteId[1]) return null;
            return space && stocks.some(stock => String(stock.id) === String(space.id) && stock.code === space.code) ? space : null;
        },
        isPharmacySpace() {
            return this.selectedStockSpace && this.selectedStockSpace.code === 'pharmacie';
        },
        isCentralSpace() {
            return this.selectedStockSpace && this.selectedStockSpace.code === 'magasin-central';
        },
    },

    mounted() {
        this.checkRole();
    },

    methods: {
        toggleClassChevron: function (htmlclass) {
            let className = $("." + htmlclass + " .chevron i").attr("class");

            if (className === "fa fa-chevron-down ico-small") {
                $("." + htmlclass + " .chevron i").removeClass(
                    "fa-chevron-down ico-small"
                );
                $("." + htmlclass + " .chevron i").addClass("fa-chevron-up ico-small");
            } else {
                $("." + htmlclass + " .chevron i").removeClass(
                    "fa-chevron-up ico-small"
                );
                $("." + htmlclass + " .chevron i").addClass(
                    "fa-chevron-down ico-small"
                );
            }
        },


        checkRole() {
            this.userCredentials.user.roles.forEach((element) => {
                if (
                    element.nom == "ROLE_ADMINISTRATEUR" ||
                    element.nom == "ROLE_PHARMACIEN" ||
                    element.nom == "ROLE_RESPONSABLE_LOGISTIQUE"
                ) {
                    this.autorisation = true;
                }
            });
            return this.autorisation;
        },

        closeSidebar() {
            const sidebar = $('#sdbr');
            if (sidebar.hasClass('shw-sdbar')) {
                sidebar.removeClass('shw-sdbar');
                // Trigger toggleSidebar in navbar to update the icon state
                this.$root.$emit('closeSidebar');
            }
        },

        onSidebarItemClick(e) {
            // Close sidebar when any menu <li> is clicked (mobile behavior),
            // but don't close when the click is only meant to expand/collapse a submenu.
            const $target = $(e.target);
            if ($target.closest('a[data-toggle="collapse"]').length) return;

            // Only react to clicks within an <li> inside the menu
            if (!$target.closest('li').length) return;

            this.closeSidebar();
        },
    },
};


